import React from 'react';
import { BadgeProps } from '@frontend/shadcn/components/ui/badge';
import { Tooltip, TooltipProvider, TooltipTrigger } from '@frontend/shadcn/components/ui/tooltip';
import { formatNumber } from '@frontend/applications/Social/utils/formatNumber';
import { CreatorProfileIcon } from '@/components/icons/creator-profile-icon';
import { DemographicData, BadgeContent, BadgeDismissButton, BadgeTooltip, BaseBadgeWrapper } from './badge-parts';

interface CreatorDemographicsMinEngagementsBadgeProps {
  data: DemographicData;
  onDismiss: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

type CombinedProps = BadgeProps & CreatorDemographicsMinEngagementsBadgeProps;

const CreatorDemographicsMinEngagementsBadge = React.forwardRef<HTMLDivElement, CombinedProps>(
  ({ data, onDismiss, ...props }, ref) => {
    const formatEngagements = (names: string[]) => names.map((num) => `${formatNumber(Number(num))}`).join(', ');

    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <BaseBadgeWrapper
                ref={ref}
                id={data.id}
                actionName="open-creator-min-engagements-filters"
                {...props}
              >
                <BadgeContent
                  icon={<CreatorProfileIcon className="mr-2 text-[#55A2DF]" />}
                  label="Min Engagement"
                  names={data.names}
                  formatNames={formatEngagements}
                />
                <BadgeDismissButton
                  onDismiss={onDismiss}
                  label="Min Engagement"
                  dismissActionName="remove-creator-min-engagements-filters"
                />
              </BaseBadgeWrapper>
            </div>
          </TooltipTrigger>
          <BadgeTooltip
            tooltipTitle="Creator Minimum Engagement Filter"
            label="Min Engagement"
            names={data.names}
            formatNames={formatEngagements}
          />
        </Tooltip>
      </TooltipProvider>
    );
  }
);

CreatorDemographicsMinEngagementsBadge.displayName = 'CreatorDemographicsMinEngagementsBadge';

export default CreatorDemographicsMinEngagementsBadge;
